"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPickersDay = void 0;
require("core-js/modules/es.symbol.description.js");
var _styles = require("@mui/material/styles");
var _xDatePickers = require("@mui/x-date-pickers");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const StyledPickersDay = exports.StyledPickersDay = (0, _styles.styled)(_xDatePickers.PickersDay, {
  shouldForwardProp: prop => prop !== 'dayIsBetween' && prop !== 'isFirstDay' && prop !== 'isLastDay' && prop !== 'isSelectDay'
})(_ref => {
  let {
    theme,
    dayIsBetween,
    isFirstDay,
    isLastDay,
    isSelectDay
  } = _ref;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, (dayIsBetween || isSelectDay) && {
    borderRadius: 0,
    backgroundColor: "".concat(theme.palette.primary.main, " !important"),
    color: "".concat(theme.palette.common.white, " !important"),
    '&:hover, &:focus': {
      backgroundColor: theme.palette.primary.dark
    }
  }), (isFirstDay || isSelectDay) && {
    borderTopLeftRadius: '50%',
    borderBottomLeftRadius: '50%'
  }), (isLastDay || isSelectDay) && {
    borderTopRightRadius: '50%',
    borderBottomRightRadius: '50%'
  }), isLastDay && {
    borderTopLeftRadius: '0',
    borderBottomLeftRadius: '0'
  });
});